module.exports = __webpack_public_path__ + "static/media/press.6dc0477e.png";